import { ToastContainer as ToastifyContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

type ToastContainerProps = {
  stacked?: boolean;
};

const ToastContainer = ({ stacked = false }: ToastContainerProps = {}) => {
  return (
    <ToastifyContainer
      position="top-right"
      hideProgressBar={true}
      newestOnTop={true}
      closeOnClick
      rtl={false}
      pauseOnFocusLoss
      draggable
      pauseOnHover
      limit={10}
      autoClose={false}
      theme="light"
      stacked={stacked}
    />
  );
};

export default ToastContainer;
export { ToastContainer };
